window.historyHelpers = {
  replacePath: function (path) {
    try {
      window.history.replaceState({}, document.title, path);
    } catch (_) { /* no-op */ }
  },
  getSearch: function () {
    try {
      return window.location.search || "";
    } catch (_) {
      return "";
    }
  },
  getHref: function () {
    try {
      return window.location.href || "";
    } catch (_) {
      return "";
    }
  },
  getPathname: function () {
    try {
      return window.location.pathname || "";
    } catch (_) {
      return "";
    }
  }
};
